export enum HubTypes {
    SMSHub = 'clientSMSHub',
    EntitySyncHub = 'entitySyncHub'
}
